import _ from 'lodash';
import axios from 'axios';
import csrfToken from '../../../shared/meta';
import axiosConfig from '../../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axiosConfig });

const headers = {
  'X-CSRF-TOKEN': csrfToken(),
};

const formDataHeaders = {
  'X-CSRF-TOKEN': csrfToken(),
  'content-type': 'multipart/form-data',
};

const base = '/api/v1/lwadmin/homepage/banner';

const buildFormData = payload => {
  const data = new FormData();

  _.forOwn(payload, (value, key) => {
    if (key === 'image') {
      !!value && data.append(key, value);
    } else {
      data.append(key, value);
    }
  });

  return data;
};

export function useGetBanners() {
  return useAxios({
    cache: { ignoreCache: true },
    url: `${base}s`,
    method: 'GET',
  }, { manual: true });
}

export function createBanner(payload) {
  return axios.post(base, buildFormData(payload), { headers: formDataHeaders });
}

export function updateBanner(id, payload) {
  return axios.put(`${base}/${id}`, buildFormData(payload), { headers: formDataHeaders });
}

export function publishBanner(id) {
  return axios.put(`${base}/${id}/publish`, { headers });
}

export function unpublishBanner(id) {
  return axios.put(`${base}/${id}/unpublish`, { headers });
}
